import React from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  
} from "react-bootstrap"; 


export default function SFAC() {
//    const [open, setOpen] = useState(0);
  

  return (
    <>
    <div className="bg-light py-5">
    
           <section className="bg-light">
                  <Container>
                    <Row className="g-4 align-items-start">
                      {/* LEFT CONTENT */}
                      <Col lg={8}>
                              <div>
                                  <h1>Venture Capital Assistance Scheme from SFAC</h1>

                                  <p>The Small Farmer's Agri-Business Consortium (SFAC) has developed the Venture Capital Assistance (VCA) Scheme to help farmers and entrepreneurs build their businesses. This scheme aims to help farmers fulfil their capital requirements for project implementation by providing a term loan to qualifying projects. We'll take a closer look at the Venture Capital Assistance Scheme in this article.</p>

                                  <h2>Scheme Goals</h2>
                                  <p>The goal of the venture capital aid programme is as follows:</p>
                                  <ul>
                                     <li>To assist entrepreneurs in establishing an agribusiness venture that has been approved by banks and other financial institutions regulated by the RBI.</li>
                                      <li>The Project Development Facility will assist farmers, producer organisations, and agriculture graduates in participating in the value chain.</li>
                                      <li>To improve state and central SFAC's prior stages.</li>
                                  </ul>


                              </div>
                        </Col>
                                <Col lg={4}>
                                             <div className="p-4 shadow rounded right-form">
                                               <Form>
                                                 <Form.Control className="mb-3" placeholder="Name" />
                                                 <Form.Control className="mb-3" placeholder="Email" />
                                                 <Form.Control className="mb-3" placeholder="Phone" />
                                                 <Form.Control className="mb-3" placeholder="Subject" />
                                                 <Button className="w-100">Get Started</Button>
                                               </Form>
                                             </div>
                               </Col>
            </Row>                      
                      <Row className="g-4 align-items-start">
                          <Col lg={12} xl={12}>
                              <div>
                                  <ul>
                                      <li>To encourage agri-entrepreneurs to participate in training and site visits in the development of agribusiness initiatives.</li>
                                      <li>To enhance rural income and employment by assuring farmers of stable markets.</li>
                                      <li>Backward linkages of agribusiness initiatives with producers would be aided.3. Salient features of the Scheme</li>
                                  </ul>

                                  <h2>Scheme Characteristics</h2>
                                  <p>The following are the characteristics of the venture capital support programme:</p>
                                  <ul>
                                    <li>Only initiatives approved by the banks/financial institutions sponsoring the project will be eligible for venture capital.</li>
                                    <li>The venture money must be repaid to the SFAC within the agreed-upon time frame, according to the repayment plan.</li>
                                    <li>Soft loans will be used by the SFAC to give venture financing to agribusiness projects.</li>
                                  </ul>

                                  <h2>Who will pay for the VCA Scheme?</h2>
                                  <p>All money will be provided by SFAC, the Small Farmers Agri Business Consortium, which operates at both the state and national levels. The Small Farmers Agribusiness Consortium (SFAC) is a non-profit organisation supported by the Ministry of Agriculture, Cooperation, and Farmers' Welfare of the Indian government.</p>

                                  <h2>Who is eligible to participate?</h2>
                                  <p>The following individuals will be eligible for assistance under the venture capital Assistance scheme:</p>

                                  <ul>
                                      <li>Individuals</li>
                                      <li>Farmers</li>
                                      <li>Firms that are a combination of a partnership and a proprietorship.</li>
                                      <li>Producer Associations.</li>
                                      <li>Companies that work with Self-Help Groups (SHGs)</li>
                                      <li>Agri-export businesses.</li>
                                      <li>Agri-business enterprises are being pursued by agriculture graduates.</li>
                                  </ul>

                                  <h2>Institutions of Finance That Are Eligible</h2>
                                  <p>Nationalized banks, SBI & its Subsidiaries, IDBI, SIDBI, NABARD, NCDC, RRBs & other State Financial Corporations are among the banks/financial institutions regulated by the Reserve Bank of India, where the Central or State Government owns more than 50%.</p>

                                  <h2>Loan Amount</h2>
                                  <p>The size of the loan for venture capital support will be determined by the project cost. Here you'll find the minimum and maximum loan amounts.</p>
                                  <p>The amount of Venture Capital Assistance will be determined by the project cost and will be the least expensive of the following:</p>
                                  <p>INR 50.00 lakhs is 26 percent of the promoter's equity.</p>
                                  <p>The amount of venture capital will be the lowest of the following for projects located in the NorthEastern Region, Hilly States (Uttarakhand, Himachal Pradesh, Jammu & Kashmir), and in all cases in any region of the country when the initiative is promoted by a registered Farmer Producers Organization:</p>
                                  <p>INR 50.00 lakhs, or 40% of the promoter's stake.</p>

                                  <h2>Application for Venture Capital Assistance</h2>
                                  <p>To apply for the Venture Capital Scheme, go to the SFAC, Government of India's official website. All they have to do now is fill out the internet form after meeting a few basic paperwork criteria. The bank or financial institution is obligated to approve the loan amount following the proper submission of the application form. If all of the relevant conditions are met, the bank will submit its authorisation to the SFAC. After that, the SFAC will determine the loan amount for qualified projects</p>

                                  <h2>Documents of Importance</h2>
                                  <p>The following documents must be attached to your application form:</p>

                                  <ul>
                                      <li>Letter of request from the promoter</li>
                                      <li>Letter of sanction from the sanctioning authority</li>
                                      <li>Appraisals accepted by banks</li>
                                      <li>A current account statement</li>
                                      <li>A copy of the partnership firm certificate is required if the firm is a partnership.</li>
                                      <li>A certificate of equity is required.</li>
                                      <li>The agreement backs up the farmer's backward linkage.</li>
                                      <li>The promoter's affidavit saying that VCA was not utilised previously.</li>
                                      <li>For unsecured loans, a CA certificate is required.</li>
                                      <li>Copy of the most recent/current bank inspection report</li>
                                      <li>The bank's affirmation that it may not release primary and collateral security without SFAC approval. Justification for taking a margin on working capital.</li>
                                  </ul>

                                  <h2>Benefits of the VCA Scheme:</h2>
                                  <p>The case is usually processed in 60-90 days.</p>
                                  <p>Appropriate for new agriculture start-ups.</p>
                                  <p>Because it's an interest-free loan, the cost of capital is lower.</p>

                                  <h2>VCA Scheme Drawbacks:</h2>
                                  <ul>
                                      <li>Large businesses require more capital, hence they are ineligible</li>
                                      <li>It is inconvenient for new entrepreneurs who are unfamiliar with complicated financial arrangements.</li>
                                      <li>Despite the fact that it is a cost-free loan, it only funds a portion of the project, therefore the duty of obtaining the remaining term loans falls on the entrepreneur.</li>
                                      <li>The approval of funding can take a lengthy time in some cases.</li>
                                  </ul>
                                  
                              </div>
                              </Col>
                          </Row>
            </Container>
        </section>
        
    </div>
    </>    
  );
};


